import type { joinStepApi } from 'app/src/services/welfareportal'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const getJoinSteps = http.get<object, DefaultBodyType, joinStepApi.JoinSteps>(apiBaseUrl + '/DEFAULT/pages/joinsteps', () => {
  return HttpResponse.json([
    {
      id: '1',
      content:
        "<span class='font-semibold'>Fase di fruizione:</span> il giorno 8 Luglio 2025 avrà inizio la fase di fruizione per chi ha effettuato l'adesione",
    },
    {
      id: '2',
      content:
        "<span class='font-semibold'>Visualizzazione sul Conto Welfare:</span> una volta avviata la fase di fruizione, il valore del tuo Premio convertito sarà visibile nel tuo conto welfare.",
    },
    {
      id: '3',
      content:
        "<span class='font-semibold'>Utilizzo del Credito Welfare:</span> potrai usufruire dei prodotti e servizi welfare disponibili nel Catalogo, chiedere rimborsi spese o fare versamenti aggiuntivi alla previdenza complementare.",
    },
  ])
})

export const joinStepsHandlers = [getJoinSteps]
